import {Point} from '@app/modules/svg/model/Point';
import {Line} from '@app/modules/svg/model/Line';

export function pointsEqual(point0: Point, point1: Point): boolean {
  return point0.x === point1.x && point0.y === point1.y;
}

export function linesEqual(line0: Line, line1: Line): boolean {
  return (pointsEqual(line0.p0, line1.p0) && pointsEqual(line0.p1, line1.p1)) ||
    (pointsEqual(line0.p0, line1.p1) && pointsEqual(line0.p1, line1.p0));
}

export function lineMidPoint({ p0, p1 }: Line): Point {
  return {
    x: (p1.x + p0.x) / 2,
    y: (p1.y + p0.y) / 2
  };
}
